import store from '../store' 
import { createRouter, createWebHistory } from 'vue-router'
import HomePage from '../views/HomePage.vue'
import AdminLayout from '../views/admin/AdminLayout.vue';
import UserManagement from '../views/admin/UserManagement.vue';
import ProductManagement from '../views/admin/ProductManagement.vue' 
import OrderManagement from '../views/admin/OrderManagement.vue' 
import ForgotPasswordPage from '../views/ForgotPasswordPage.vue'; // 【新增】
import ResetPasswordPage from '../views/ResetPasswordPage.vue';   // 【新增】

const routes = [
  { path: '/', name: 'HomePage', component: HomePage },
  { path: '/product/:id', name: 'ProductDetailPage', component: () => import('../views/ProductDetailPage.vue') },
  { path: '/login', name: 'LoginPage', component: () => import('../views/LoginPage.vue'),meta: { hideNavbar: true, hideFooter: true } },
  { path: '/register', name: 'RegisterPage', component: () => import('../views/RegisterPage.vue'),meta: { hideNavbar: true, hideFooter: true } },
  { path: '/cart', name: 'CartPage', component: () => import('../views/CartPage.vue') },
  { path: '/orders', name: 'OrdersPage', component: () => import('../views/OrdersPage.vue') },
  { path: '/addresses', name: 'AddressPage', component: () => import('../views/AddressPage.vue') },
  { path: '/checkout', name: 'CheckoutPage', component: () => import('../views/CheckoutPage.vue') },
  { path: '/order-success/:orderNumber', name: 'OrderSuccessPage', component: () => import('../views/OrderSuccessPage.vue') },
  { path: '/products', name: 'ProductList', component: () => import('../views/ProductListPage.vue') },

  { 
    path: '/hot', 
    name: 'HotProductsPage', 
    component: () => import('../views/HotProductsPage.vue') 
  },

  { 
    path: '/profile', 
    name: 'UserProfilePage', 
    component: () => import('../views/UserProfilePage.vue'),
    redirect: '/profile/basic',
    children: [
      { path: 'basic', name: 'BasicProfile', component: () => import('../components/profile/BasicInfo.vue') },
      { path: 'password', name: 'ChangePassword', component: () => import('../components/profile/ChangePassword.vue') },
      { path: 'wallet', name: 'Walle', component:()=> import('../components/profile/WalletPage.vue') }
    ]
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPasswordPage,
    meta: { hideNavbar: true } // 隐藏导航栏以提供沉浸式体验
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: ResetPasswordPage,
    meta: { hideNavbar: true }
  },
  {
    path: '/admin',
    component: AdminLayout,
    // 路由守卫：进入/admin路径前检查是否为管理员
    beforeEnter: (to, from, next) => {
      // 假设你的store已经初始化
      if (store.getters.isAdmin) {
        next(); // 是管理员，放行
      } else {
        next('/'); // 不是管理员，跳转到首页
      }
    },
    children: [
      { path: '', redirect: '/admin/users' }, // 默认跳转到用户管理
      { path: 'users', name: 'UserManagement', component: UserManagement },
      { path: 'products', component: ProductManagement },
      { path: 'orders', component: OrderManagement }
    ],
    meta: { hideNavbar: true, hideFooter: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router